import { PointArray } from '@editor/interfaces/attribute'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

export const TEMP_ID_PREFIX = 'temp_polyline'
export const WORKING_ID_PREFIX = 'working_polyline'

export interface PolylineState {
  /**
   * Points that make up the working polyline.
   */
  workingPoints: PointArray[]
}

const initialState: PolylineState = {
  workingPoints: [],
}

export const slice = createSlice({
  name: 'blueprint-editor/tools/polyline',
  initialState,
  reducers: {
    addWorkingPoint: (state, action: PayloadAction<PointArray>) => {
      state.workingPoints.push(action.payload)
    },

    // undoLastWorkingPolyline: (state) => {
    //   if (RealTimeStore.workingPoints.length > 0) {
    //     RealTimeStore.workingPoints.pop()
    //   } else if (state.polylines.length > 0) {
    //     const lastPolyline = state.polylines[state.polylines.length - 1]
    //     state.polylines.pop()
    //     RealTimeStore.workingPoints = lastPolyline.drawing_parameters.points.map((point) => new Vector3(...point))
    //   }

    //   state.isDirty = RealTimeStore.workingPoints.length > 0 || state.polylines.length > 0
    //   state.isSaveable = RealTimeStore.workingPoints.length === 0 && state.polylines.length > 0
    // },

    undoWorkingPolyline: (state) => {
      state.workingPoints.pop()
    },

    // Reset
    reset: () => initialState,
  },
})

export const {
  addWorkingPoint,
  undoWorkingPolyline,

  // Reset
  reset,
} = slice.actions

export default slice.reducer
